import Vue from "vue";
import VueRouter from "vue-router";

import Login from "../views/Login.vue";

const Funcionarios = () => import("../views/Funcionarios.vue");
const Parceiros = () => import("../views/Parceiros.vue");
const Solicitacao = () => import("../views/Solicitação.vue");
const SolicitacaoFuncionario = () => import("../views/SolicitacaoFuncionario.vue");
const Admins = () => import("../views/Admins.vue");
const Suporte = () => import("../views/Suporte.vue");
const TodosUsuarios = () => import("../views/TodosUsuarios.vue");
const NewHome = () => import("../views/NewHome.vue");
const Configuracoes = () => import("../views/Configuracoes.vue");
const ConfiguracoesFuncionario = () => import("../views/ConfiguracoesFuncionario.vue");
const Bikers = () => import("../views/Bikers.vue");
const Fixo = () => import("../views/Fixo.vue");
const Motoboys = () => import("../views/Motoboys.vue");
const EditaBairros = () => import("../views/EditaBairros.vue");
const EditarRuas = () => import("../views/EditarRuas.vue");
const ListaRuas = () => import("../views/EditarRuas.vue");

const EditarRegras = () => import("../views/EditarRegras.vue");


const RouterView = () => import("../views/RouterView.vue");
const EditaEntregas = () => import("../views/EditaEntregas.vue");
const MapaEntregadores = () => import("../views/MapaEntregadores.vue");
const SolicitacaoDetalhes = () => import("../views/SolicitacaoDetalhes.vue");
const AdminSolicita = () => import("../views/SolicitacaoAdmins.vue");
const BairroTabela = () => import("../views/BairroTabela.vue");
const PorcentagemChuva = () => import("../views/PorcentagemChuva.vue");
const PorcentagemCadastro = () => import("../views/PorcentagemCadastro.vue");

const Caixa = () => import("../views/Caixa.vue");
const ConfiguracoesCaixa = () => import("../views/ConfiguracoesCaixa.vue");
const DevolucaoPendente = () => import("../views/DevolucaoPendente.vue");
const ConfiguraEndereco = () => import("../views/ConfiguraEndereco.vue");
const AcertoViewRouter = () => import("../views/AcertoViewRouter.vue");
const TabelaPadrao = () => import("../views/TabelaPadrao.vue");
const HistoricoEntregas = () => import("../views/HistoricoEntregas.vue");
const HistoricoEntregasFuncionario = () => import("../views/HistoricoEntregasFuncionario.vue");
const PagamentoParceiros = () => import("../views/PagamentoParceiros.vue");
const Acerto = () => import("../views/Acerto.vue");
const Contestacoes = () => import("../views/Contestacoes.vue");
const Tabela = () => import("../views/Tabela.vue");
const TabelaDistribuicao = () => import("../views/TabelaDistribuicao.vue");
const Saldo = () => import("../views/Saldo.vue");
const P404 = () => import("../views/P404.vue");
const UploadPDF = () => import("../views/UploadPDF.vue");
const TermosUso = () => import("../views/TermosUso.vue");
const EditarDiaSemana = () => import("../views/EditarDiaSemana.vue");
const EditarTurno = () => import("../views/EditarTurno.vue");
const StatusAgendamento = () => import("../views/StatusAgendamento.vue");
const Maintenance = () => import("../views/Maintenance.vue");
const Vantagens = () => import("../views/ClubeVantagens.vue");
const CadastroEntrega = () => import("../views/CadastroEntrega.vue");
const CadastroEntregaEndereco = () => import("../views/CadastroEntregaEndereco.vue");

const CadastroDistribuicao = () => import("../views/CadastroDistribuicao.vue");
const RelatorioEntregas = () => import("../views/RelatorioAdmin.vue");
const RelatorioEntregasParceiro = () => import("../views/RelatorioParceiro.vue");

const AcertoEntregador = () => import("../views/AcertoEntregador.vue");
const P501 = () => import("../views/P501.vue");
const AcertoParceiro = () => import("../views/AcertoParceiro.vue");
const AcertoMotoboy = () => import("../views/AcertoMotoboy.vue");
const TabelaParceiro = () => import("../views/TabelaParceiro.vue");
const ConfiguracoesAgen = () => import("../views/ConfiguracoesAgen.vue");
const TheContainer = () => import("../components/TheContainer.vue");
const RuasPadrao = () => import("../views/RuasPadrao.vue");
const RuasParceiro = () => import("../views/RuasParceiro.vue");

Vue.use(VueRouter);

export const appRoutes = [
         {
           path: "/manutencao",
           component: Maintenance,
           name: "manutencao"
         },
         {
           path: "/",
           redirect: {
             name: "Login"
           }
         },

         {
           path: "/login",
           component: Login,
           name: "Login",
           meta: { roles: "AD|SA|PE|CO|MT" }
         },
         {
           path: "/",
           component: TheContainer,
           name: "",
           children: [{
                 path: "home",
                 component: NewHome,
                 name: "Tela Inicial",
                 meta: {
                   roles: "SP | SF"
                 }
               },


               {
                 path: "lista_ruas",
                 component: ListaRuas,
                 name: "lista_ruas",
                 meta: {
                   roles: "SP|SF"
                 }
               },
           ]
          },
         {
           path: "/",
           component: TheContainer,
           name: "",
           children: [
             {
               path: "home",
               component: NewHome,
               name: "Tela Inicial",
               meta: { roles: "AD|SA|PE|CO|MT" }
             },

             //  {
             //    path: "distribuicao",
             //    component: Distribuicao,
             //    name: "distribuição",
             //    meta: { roles: "AD|SA" }
             //  },
             {
               path: "contestacoes",
               component: Contestacoes,
               name: "contestações",
               meta: { roles: "AD|SA|SF" }
             },
             {
               path: "/termos",
               component: RouterView,
               name: "Termos",
               meta: { roles: "AD|SA|PE|CO|MT" },
               redirect: "/home",
               children: [
                 {
                   path: "termos_uso",
                   component: TermosUso,
                   name: "Termos de uso",
                   meta: { roles: "AD|SA|PE|CO|MT" }
                 },
                 {
                   path: "vantagens",
                   component: Vantagens,
                   name: "Clube de vantagens",
                   meta: { roles: "AD|SA|PE|MT" }
                 },
                 {
                   path: "upload_arquivo",
                   component: UploadPDF,
                   name: "Upload de arquivos",
                   meta: { roles: "AD|SA" }
                 }
               ]
             },

             //  {
             //    path: "AgendamentoMotoboy",
             //    component: AgendamentoMotoboy,
             //    name: "AgendamentoMotoboy",
             //    meta: { roles: "AD|SA|PE|CO|MT" }
             //  },
             {
               path: "dias_semana",
               component: EditarDiaSemana,
               name: "Editar dias da semana",
               meta: { roles: "SA|AD" }
             },
             {
               path: "turnos",
               component: EditarTurno,
               name: "Editar turnos",
               meta: { roles: "SA|AD" }
             },
             {
               path: "status_agendamento",
               component: StatusAgendamento,
               name: "Editar status do agendamento",
               meta: { roles: "SA|AD" }
             },
             //  {
             //    path: "agendamento",
             //    component: Agendamento,
             //    name: "Agendamento",
             //    meta: { roles: "AD|SA|PE|CO" }
             //  },
             {
               path: "ConfiguracoesAgen",
               component: ConfiguracoesAgen,
               name: "Configurações do agendamento",
               meta: { roles: "AD|SA" }
             },

             {
               path: "/edita_rua_bairro",
               component: RouterView,
               name: "Edita Rua Bairro",
               meta: { roles: "AD|SA" },
               redirect: "/home",
               children: [
                 {
                   path: "/edita_rua_bairro/edita_bairro",
                   component: EditaBairros,
                   props: true,
                   name: "Edita bairros",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Edita_bairros",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/edita_rua_bairro/bairro_sem_tabela",
                   component: BairroTabela,
                   props: true,
                   name: "Bairros sem tabela",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Bairros_sem_tabela",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/edita_rua_bairro/editar_regras",
                   component: EditarRegras,
                   props: true,
                   name: "Editar regras",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
                 {
                   path: "/edita_rua_bairro/edita_ruas",
                   component: EditarRuas,
                   props: true,
                   name: "Edita ruas",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/edita_rua_bairro/ruas_padrao",
                   component: RuasPadrao,
                   props: true,
                   name: "Ruas padrão",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/edita_rua_bairro/tabela_rua_parceiro",
                   component: RuasParceiro,
                   props: true,
                   name: "Tabela ruas parceiro",
                   meta: { roles: "AD|SA" }
                 },

                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Edita_ruas",
                   meta: { roles: "AD|SA" }
                 }
               ]
             },
             //  {
             //    path: "edita_areas",
             //    component: EditaArea,
             //    name: "Editar areas",
             //    meta: { roles: "AD|SA" }
             //  },
             {
               path: "/controle",
               component: RouterView,
               name: "Controle",
               meta: { roles: "AD|SA|SP" },
               redirect: "/home",
               children: [
                 {
                   path: "mapa_entregadores",
                   component: MapaEntregadores,
                   name: "Mapa entregadores",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "solicitacao_detalhes",
                   component: SolicitacaoDetalhes,
                   name: "Solicitações em andamento",
                   meta: { roles: "AD|SA|SP" }
                 },

                 {
                   path: "solicitacao_admin",
                   component: AdminSolicita,
                   name: "Abrir solicitação",
                   meta: { roles: "AD|SA" }
                 }
               ]
             },

             {
               path: "/solicitar",
               component: RouterView,
               name: "Solicitar",
               meta: { roles: "FU" },
               redirect: "/home",
               children: [
                 {
                   path: "solicitacoes_funcionario",
                   component: SolicitacaoFuncionario,
                   name: "solicitacoes_funcionario",
                   meta: { roles: "FU" }
                 }
               ]
             },
             {
               path: "/solicitar",
               component: RouterView,
               name: "Solicitar",
               meta: { roles: "CO" },
               redirect: "/home",
               children: [
                 {
                   path: "solicitacoes",
                   component: Solicitacao,
                   name: "Solicitações",
                   meta: { roles: "CO" }
                 }
               ]
             },
             {
               path: "tabela_bairros",
               component: TabelaParceiro,
               name: "Tabela de preços",
               meta: { roles: "CO" }
             },
             {
               path: "funcionarios",
               component: Funcionarios,
               name: "Funcionários",
               meta: { roles: "CO" }
             },
             {
               path: "/entregas",
               component: RouterView,
               name: "Entregas_home",
               meta: { roles: "FU" },
               redirect: "/home",
               children: [
                 {
                   path: "historico_funcionario",
                   component: HistoricoEntregasFuncionario,
                   name: "Histórico",
                   meta: { roles: "FU" }
                 }
               ]
             },
             {
               path: "/entregas",
               component: RouterView,
               name: "Entregas_home",
               meta: {
                 roles: "SP"
               },
               redirect: "/home",
               children: [{
                 path: "historico_funcionario",
                 component: HistoricoEntregasFuncionario,
                 name: "Histórico",
                 meta: {
                   roles: "SP"
                 }
               }]
             },
             {
               path: "/entregas",
               component: RouterView,
               name: "Entregas_home",
               meta: { roles: "AD|SA|PE|CO|MT" },
               redirect: "/home",
               children: [
                 {
                   path: "historico",
                   component: HistoricoEntregas,
                   name: "Histórico",
                   meta: { roles: "AD|SA|PE|CO|MT" }
                 },

                 {
                   path: "cadastro_entrega",
                   component: CadastroEntregaEndereco,
                   name: "Cadastrar entrega",
                   meta: { roles: "AD|SA|PE|MT" }
                 },
                 {
                   path: "cadastro_distribuicao",
                   component: CadastroDistribuicao,
                   name: "Cadastrar distribuição",
                   meta: { roles: "AD|SA|PE|MT" }
                 },
                 {
                   path: "editar_varias",
                   component: EditaEntregas,
                   name: "Editar entregas",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "fixo",
                   component: Fixo,
                   name: "Entregador fixo",
                   meta: { roles: "AD|SA" },

                 },
                 {
                   path: "porcentagem_chuva",
                   component: PorcentagemChuva,
                   props: true,
                   name: "Porcentagem chuva",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
                 {
                   path: "porcentagem_cadastro",
                   component: PorcentagemCadastro,
                   props: true,
                   name: "Porcentagem chuva",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
               ]
             },
             {
               path: "/configuracoes_funcionario",
               component: RouterView,
               name: "Configurações",
               meta: { roles: "FU" },
               redirect: "/home",
               children: [
                 {
                   path: "/configuracoes/informacoes_pessoas_funcionario",
                   component: ConfiguracoesFuncionario,
                   name: "Editar dados pessoais funcionario",
                   meta: { roles: "FU" }
                 }
               ]
             },
             {
               path: "/configuracoes",
               component: RouterView,
               name: "Configuracoes",
               meta: { roles: "AD|SA|PE|CO|MT|SP|SF" },
               redirect: "/home",
               children: [
                 {
                   path: "/configuracoes/informacoes_pessoas",
                   component: Configuracoes,
                   name: "Editar dados pessoais",
                   meta: {
                     roles: "AD|SA|PE|CO|MT|SP|SF"
                   }
                 },
                 {
                   path: "/configuracoes/endereco",
                   component: ConfiguraEndereco,
                   name: "Editar endereço",
                   meta: { roles: "CO" }
                 }
               ]
             },
             {
               path: "/financeiro",
               component: AcertoViewRouter,
               name: "Financeiro",
               meta: { roles: "PE|CO|MT" },
               redirect: "/home",
               children: [
                 {
                   path: "/financeiro/saldo",
                   component: Saldo,
                   props: true,
                   name: "Saldo e extrato",
                   meta: { roles: "CO|PE|MT" }
                 },
                 {
                   path: "/financeiro/relatorio_entregas_parceiro",
                   component: RelatorioEntregasParceiro,
                   props: true,
                   name: "Relatório de entregas parceiro",
                   meta: { roles: "CO" }
                 },
                ]






             },

             {
               path: "/financeiro",
               component: AcertoViewRouter,
               name: "Financeiro",
               meta: {
                 roles: "AD|SA|SF"
               },
               redirect: "/home",
               children: [
                 {
                   path: "/financeiro/caixa",
                   component: Caixa,
                   props: true,
                   name: "Caixa",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
                 {
                   path: "/financeiro/configuracoes",
                   component: ConfiguracoesCaixa,
                   props: true,
                   name: "Configurações do caixa",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
                 {
                   path: "/financeiro/devolucao",
                   component: DevolucaoPendente,
                   props: true,
                   name: "Devoluções pendentes",
                   meta: {
                     roles: "AD|SA|SF"
                   }
                 },
                 {
                   path: "/financeiro/relatorio_entregas",
                   component: RelatorioEntregas,
                   props: true,
                   name: "Relatório de entregas",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
                 //  {
                 //    path: "/financeiro/pagamento_parceiros",
                 //    component: P501,
                 //    props: true,
                 //    name: "Frequencia pagamentos",
                 //    meta: { roles: "AD|SA" }
                 //  },

                 {
                   path: "/financeiro/acerto",
                   component: Acerto,
                   props: true,
                   name: "Acerto",
                   meta: {
                     roles: "AD|SA|SF"
                   }
                 },
                 {
                   path: "",
                   component: AcertoViewRouter,
                   props: true,
                   name: "Acerto",
                   meta: {
                     roles: "AD|SA|SF"
                   },
                   children: [{
                     path: "/financeiro/acerto/detalhes",
                     component: RouterView,
                     props: true,
                     name: "",
                     meta: {
                       roles: "AD|SA|SF"
                     },
                     children: [{
                         path: "/financeiro/acerto/detalhes/acerto_biker/:id",
                         component: AcertoEntregador,
                         name: "",
                         props: true,
                         redirect: "/financeiro/acerto",
                         meta: {
                           roles: "AD|SA|SF"
                         },
                         children: [{
                           path: "",
                           component: AcertoEntregador,
                           props: true,
                           name: "Acerto_Entregador",
                           meta: {
                             roles: "AD|SA|SF"
                           }
                         }]
                       },
                       {
                         path: "/financeiro/acerto/detalhes/acerto_motoboy/:id",
                         component: AcertoMotoboy,
                         name: "",
                         props: true,
                         redirect: "/financeiro/acerto",
                         meta: {
                           roles: "AD|SA|SF"
                         },
                         children: [{
                           path: "",
                           component: AcertoEntregador,
                           props: true,
                           name: "Acerto motoboy",
                           meta: {
                             roles: "AD|SA|SF"
                           }
                         }]
                       },
                       {
                         path: "/financeiro/acerto/detalhes/acerto_parceiro/:id",
                         component: AcertoParceiro,
                         name: "",
                         props: true,
                         redirect: "/financeiro/acerto",
                         meta: {
                           roles: "AD|SA"
                         },
                         children: [{
                           path: "",
                           component: AcertoEntregador,
                           props: true,
                           name: "Acerto parceiro",
                           meta: {
                             roles: "AD|SA"
                           }
                         }]
                       }
                     ]
                   }]
                 }
               ]
             },
             {
               path: "tabela",
               component: Tabela,
               name: "Tabelas de preços_tabela",
               meta: { roles: "AD|SA" }
             },
             {
               path: "/tabelas_preco",
               component: RouterView,
               name: "Tabelas Preco",
               meta: { roles: "AD|SA|PE|CO|MT" },
               redirect: "/home",
               children: [
                 {
                   path: "/tabelas_preco/tabela_distribuicao",
                   component: TabelaDistribuicao,
                   props: true,
                   name: "Tabelas de preços distribuição",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "",
                   component: AcertoViewRouter,
                   props: true,
                   name: "Tabelas_Preco_Acerto",
                   meta: { roles: "AD|SA" },
                   children: [
                     {
                       path: "/tabelas_preco/tabela_distribuicao/detalhes",
                       component: RouterView,
                       props: true,
                       name: "",
                       meta: { roles: "AD|SA" },
                       children: [
                         {
                           path: "/tabelas_preco/tabela_distribuicao/detalhes",
                           component: AcertoEntregador,
                           name: "",
                           props: true,
                           redirect: "/financeiro/acerto",
                           meta: { roles: "AD|SA" },
                           children: [
                             {
                               path: "",
                               component: AcertoEntregador,
                               props: true,
                               name: "Acerto_Biker",
                               meta: { roles: "AD|SA" }
                             }
                           ]
                         }
                       ]
                     }
                   ]
                 },

                 {
                   path: "/tabelas_preco/tabela_padrao",
                   component: TabelaPadrao,
                   props: true,
                   name: "Tabelas de preços padrão",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/tabelas_preco/tabela",
                   component: Tabela,
                   props: true,
                   name: "Tabelas de preços entregas simples",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/tabelas_preco/tabela_distribuicao",
                   component: TabelaDistribuicao,
                   props: true,
                   name: "Tabelas de preços_distribuição2",
                   meta: { roles: "AD|SA" }
                 },
                 //  {
                 //    path: "/tabelas_preco/edita_areas",
                 //    component: EditaArea,
                 //    props: true,
                 //    name: "Editar áreas entregas simples",
                 //    meta: { roles: "AD|SA" }
                 //  },
                 {
                   path: "/tabelas_preco/tabela_distribuicao",
                   component: TabelaDistribuicao,
                   props: true,
                   name: "Tabelas de preços_distribuição",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "",
                   component: AcertoViewRouter,
                   props: true,
                   name: "Acerto_View",
                   meta: {
                     roles: "AD|SA|SF"
                   },
                   children: [
                     {
                       path: "/financeiro/acerto/detalhes",
                       component: RouterView,
                       props: true,
                       name: "",
                       meta: {
                         roles: "AD|SA|SF"
                       },
                       children: [
                         {
                           path: "/financeiro/acerto/detalhes/acerto_biker/:id",
                           component: AcertoEntregador,
                           name: "",
                           props: true,
                           redirect: "/financeiro/acerto",
                           meta: {
                             roles: "AD|SA|SF"
                           },
                           children: [
                             {
                               path: "",
                               component: AcertoEntregador,
                               props: true,
                               name: "Financeiro_Acerto_Biker",
                               meta: {
                                 roles: "AD|SA|SF"
                               }
                             }
                           ]
                         }
                       ]
                     }
                   ]
                 }
               ]
             },
             {
               path: "/usuarios",
               component: RouterView,
               name: "Usuarios",
               meta: { roles: "AD|SA" },
               redirect: "/home",
               children: [
                 {
                   path: "/usuarios/bikers",
                   component: Bikers,
                   props: true,
                   name: "Usuarios_Bikers",
                   meta: {
                     roles: "AD|SA|SP"
                   }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Bikers_View",
                   meta: {
                     roles: "AD|SA|SP"
                   }
                 },
                 {
                   path: "/usuarios/motoboys",
                   component: Motoboys,
                   props: true,
                   name: "Usuarios_Motoboys",
                   meta: {
                     roles: "AD|SA|SP"
                   }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Motoboys_Home",
                   meta: {
                     roles: "AD|SA|SP"
                   }
                 },
                 {
                   path: "/usuarios/parceiros",
                   component: Parceiros,
                   props: true,
                   name: "Usuarios_Parceiros",
                   meta: {
                     roles: "AD|SA|SP"
                   }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Parceiros_View",
                   meta: {
                     roles: "AD|SA|SP"
                   }
                 },
                 {
                   path: "/usuarios/admins",
                   component: Admins,
                   props: true,
                   name: "Usuarios_Administradores",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Administradores_View",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "/usuarios/suporte",
                   component: Suporte,
                   props: true,
                   name: "Usuarios_Suporte",
                   meta: {
                     roles: "AD|SA"
                   }
                 }, {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Suporte_View",
                   meta: {
                     roles: "AD|SA"
                   }
                 },
                 {
                   path: "/usuarios/todos",
                   component: TodosUsuarios,
                   props: true,
                   name: "Todos_Usuarios",
                   meta: { roles: "AD|SA" }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Todos usuarios_view",
                   meta: { roles: "AD|SA" }
                 }
               ]
             },
             {
               path: "/usuarios",
               component: RouterView,
               name: "Usuarios",
               meta: {
                 roles: "SP"
               },
               redirect: "/home",
               children: [{
                   path: "/usuarios/bikers",
                   component: Bikers,
                   props: true,
                   name: "Usuarios_Bikers",
                   meta: {
                     roles: "SP"
                   }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Bikers_View",
                   meta: {
                     roles: "SP"
                   }
                 },
                 {
                   path: "/usuarios/motoboys",
                   component: Motoboys,
                   props: true,
                   name: "Usuarios_Motoboys",
                   meta: {
                     roles: "SP"
                   }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Motoboys_Home",
                   meta: {
                     roles: "SP"
                   }
                 },
                 {
                   path: "/usuarios/parceiros",
                   component: Parceiros,
                   props: true,
                   name: "Usuarios_Parceiros",
                   meta: {
                     roles: "SP"
                   }
                 },
                 {
                   path: "",
                   component: RouterView,
                   props: true,
                   name: "Parceiros_View",
                   meta: {
                     roles: "SP"
                   }
                 },


               ]
             }
           ]
         },

         {
           path: "/501",
           component: P501,
           name: "501",
           meta: { roles: "AD|SA|PE|CO|MT" }
         },
         {
           path: "*",
           component: P404,
           name: "404",
           meta: { roles: "AD|SA|PE|CO|MT" }
         }
       ];

const router = new VueRouter({
  mode: "hash",
  linkActiveClass: "active",
  routes: appRoutes
});

export default router;
